import React from 'react';
import DefaultButton, { DefaultButtonProps } from '.';
import type { ConfirmationFormItem } from '../ConfirmationDialog';
import {
  WithConfirmation,
  type WithConfirmationProps,
} from '../ConfirmationDialog/WithConfirmation';

export type ConfirmationButtonProps<T extends readonly ConfirmationFormItem<string>[]> = Omit<
  DefaultButtonProps,
  'onClick'
> & {
  confirmation: Omit<WithConfirmationProps<T>, 'children'>;
  onClick: WithConfirmationProps<T>['onConfirm'];
};

function ConfirmationButton<T extends readonly ConfirmationFormItem<string>[]>(
  props: ConfirmationButtonProps<T>,
) {
  if (!props.confirmation.message) {
    return <DefaultButton {...props} />;
  }
  return (
    <WithConfirmation {...props.confirmation} onConfirm={props.onClick}>
      {(open) => <DefaultButton {...props} onClick={open} />}
    </WithConfirmation>
  );
}

export default ConfirmationButton;
